import script from "./DoctorInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./DoctorInfoCard.vue?vue&type=style&index=0&id=2ce0341a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce0341a"]])

export default __exports__